import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SpecialHoursPeriodInterface } from '@vendasta/listing-products';
import { SpecialHoursDateTimeInterface } from './business-hours.interface';
import { convertToSpecialHoursDateTime } from '../business-hours';
import { Observable } from 'rxjs';
import { EditSpecialHoursDialogComponent } from '../edit-special-hours-dialog/edit-special-hours-dialog.component';

@Component({
  selector: 'forms-special-hours',
  templateUrl: './special-hours.component.html',
  styleUrls: ['./special-hours.component.scss'],
})
export class SpecialHoursComponent {
  @Input() control: UntypedFormControl;
  @Input() appearance: 'outline' | 'standard' = 'standard';
  @Input() loading$: Observable<boolean>;
  @Output() changes = new EventEmitter();

  private editDialogRef: MatDialogRef<EditSpecialHoursDialogComponent>;

  constructor(private dialog: MatDialog) {}

  getSpecialHours(): SpecialHoursPeriodInterface[] {
    return this.control?.value || [];
  }

  getSpecialDateTime(): SpecialHoursDateTimeInterface[] {
    const specialHours = this.control?.value || [];
    return convertToSpecialHoursDateTime(specialHours);
  }

  openEditDialog(): void {
    if (this.control.disabled) {
      return;
    }

    this.control.markAsTouched();
    this.dialog.closeAll();
    this.editDialogRef = this.dialog.open(EditSpecialHoursDialogComponent, {
      disableClose: true,
      width: '660px',
      maxWidth: '100vw',
    });
    this.editDialogRef.componentInstance.control = new UntypedFormControl(this.control.value);
    this.editDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.control.setValue(result);
        this.control.markAsDirty();
        this.changes.emit();
      }
      this.editDialogRef = null;
    });
  }
}
